import {autoinject} from "aurelia-framework";
import {Router} from "aurelia-router";
import {Address, CartService} from "../cart-service";
import {countryService} from "../country-service";
import {allCountries} from "../models";

@autoinject()
export class Page4Address{

    private shippingAddress: Address = new Address();

    private valid: boolean = true;


    constructor(private router: Router, private cartService: CartService) {
        window.scrollTo(0, 0);
    }

    attached() {

        const urlCountryCode = countryService.getCountryCodeFromUrl();
        this.cartService.getShippingAddress().then( address => {
            this.shippingAddress = address
            const country = allCountries.find(country => country.countryCode.toLowerCase() === urlCountryCode.toLowerCase());
            this.shippingAddress.country = country.countryCode;
        });

    }

    submit() {
        if (this.valid) {
            this.cartService.saveShippingAddress(this.shippingAddress);
            this.router.navigate("page5-confirm")
        }
    }



}
